export default __webpack_public_path__ + "media/projects/blue2-3d345b35.svg";